'use client'

import { Button } from '@ariakit/react'
import classNames from 'classnames'
import useEmblaCarousel from 'embla-carousel-react'
import type { ReactNode } from 'react'
import { useCallback, useEffect, useState } from 'react'

import Icon from '../Icon/Icon'
import styles from './CategoryCarousel.module.scss'

export default function CategoryCarousel({
  children,
}: Readonly<{ children: ReactNode }>) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    slidesToScroll: 2,
  })
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

  const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi])
  const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi])

  useEffect(() => {
    if (!emblaApi) {
      return
    }

    setPrevBtnDisabled(!emblaApi.canScrollPrev())
    setNextBtnDisabled(!emblaApi.canScrollNext())

    emblaApi.on('reInit', () => {
      setPrevBtnDisabled(!emblaApi.canScrollPrev())
      setNextBtnDisabled(!emblaApi.canScrollNext())
    })
    emblaApi.on('select', () => {
      setPrevBtnDisabled(!emblaApi.canScrollPrev())
      setNextBtnDisabled(!emblaApi.canScrollNext())
    })
  }, [emblaApi])

  return (
    <div className={styles['category-carousel']}>
      <div ref={emblaRef} className={styles['category-carousel__container']}>
        <div className={styles['category-carousel__slides']}>{children}</div>
      </div>
      <Button
        className={classNames(
          styles['category-carousel__navigation'],
          styles['category-carousel__navigation__prev'],
        )}
        onClick={scrollPrev}
        disabled={prevBtnDisabled}
      >
        <Icon icon="arrow_left" />
        <span className="sr-only">Previous</span>
      </Button>
      <Button
        className={classNames(
          styles['category-carousel__navigation'],
          styles['category-carousel__navigation__next'],
        )}
        onClick={scrollNext}
        disabled={nextBtnDisabled}
      >
        <Icon icon="arrow_right" />
        <span className="sr-only">Next</span>
      </Button>
    </div>
  )
}
